import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A0A0B] hairline-t">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <img src="/assets/logo-nav.webp" alt="Zorem Commodities" width="28" height="42" className="h-9 w-auto" loading="lazy" />
          <span className="font-display text-sm tracking-[0.35em] text-[#F4F4F6]">ZOREM</span>
        </div>
        <p className="mt-6 text-sm text-zinc-500 leading-relaxed max-w-md">
          Zorem Commodities LLC is the disciplined conduit through which the
          world's mineral resources flow — meticulously verified, and delivered
          with absolute integrity. Facilitator, not broker.
        </p>
        <p className="mt-4 font-mono2 text-[11px] tracking-[0.15em] text-zinc-600 uppercase">
          300 W. Clarendon Ave, Suite 325 · Phoenix, AZ 85013
        </p>
      </div>
      <div>
        <h4 className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#C9A227] mb-5">Navigate</h4>
        <nav className="flex flex-col gap-3 text-sm text-zinc-400" aria-label="Footer">
          <Link data-testid="footer-link-about" to="/about" className="hover:text-[#D4AF37] transition-colors">About</Link>
          <Link data-testid="footer-link-process" to="/process" className="hover:text-[#D4AF37] transition-colors">The Pathway</Link>
          <a data-testid="footer-link-commodities" href="/#commodities" className="hover:text-[#D4AF37] transition-colors">Commodities</a>
          <Link data-testid="footer-link-compliance" to="/compliance" className="hover:text-[#D4AF37] transition-colors">Compliance</Link>
          <a data-testid="footer-link-verification" href="/#verification" className="hover:text-[#D4AF37] transition-colors">Verification</a>
          <a data-testid="footer-link-insights" href="/#insights" className="hover:text-[#D4AF37] transition-colors">Insights</a>
          <a data-testid="footer-link-contact" href="/#contact" className="hover:text-[#D4AF37] transition-colors">Contact</a>
        </nav>
      </div>
      <div>
        <h4 className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#C9A227] mb-5">Legal</h4>
        <nav className="flex flex-col gap-3 text-sm text-zinc-400" aria-label="Legal">
          <Link data-testid="footer-link-terms" to="/legal/terms" className="hover:text-[#D4AF37] transition-colors">Terms of Business</Link>
          <Link data-testid="footer-link-privacy" to="/legal/privacy" className="hover:text-[#D4AF37] transition-colors">Privacy Notice</Link>
          <Link data-testid="footer-link-aml" to="/legal/aml" className="hover:text-[#D4AF37] transition-colors">AML / KYC Policy</Link>
        </nav>
      </div>
    </div>
    <div className="hairline-t">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 space-y-4">
        <p className="text-xs text-zinc-600 leading-relaxed max-w-4xl">
          Disclaimer: Content on this website is provided for general information only and does not
          constitute an offer, solicitation, or recommendation to buy or sell any commodity, security,
          or financial instrument, nor investment, legal, or tax advice. Indicative prices, including
          the XAU/USD spot ticker and any calculator outputs, are display values — not executable
          rates or settlement prices. Physical commodities involve risk, including price volatility
          and logistics disruption. All engagement is subject to counterparty verification under our
          AML/KYC policy. Zorem Commodities LLC acts as a facilitator and execution partner, not as a
          broker, exchange, or investment adviser.
        </p>
        <div className="flex flex-wrap justify-between gap-4">
          <span className="text-xs text-zinc-600">© 2026 Zorem Commodities LLC. All rights reserved.</span>
          <span className="text-xs text-zinc-600">300 W. Clarendon Ave, Suite 325, Phoenix, AZ 85013 · b@zoremcommodities.com</span>
        </div>
      </div>
    </div>
  </footer>
);
